// Sterling & Hayes — Law Firm (Case-file dossier)
export const META = { brand: 'Sterling & Hayes', tag: 'Solicitors · Lincoln’s Inn', est: '1934' };
export const ROUTES = [
  { id: 'home', label: 'Chambers' },
  { id: 'practice', label: 'Practice Areas' },
  { id: 'counsel', label: 'Counsel' },
  { id: 'inquiry', label: 'Confidential' },
];
export const PRACTICES = [
  { ref: 'PA-01', t: 'Private Client & Trusts', d: 'Wills, succession, family trusts, generational planning. Average matter value £4M — £40M.', led: 'Led by Whitford QC' },
  { ref: 'PA-04', t: 'Commercial Litigation', d: 'High-value disputes, fraud, shareholder actions. Recent matters before the Commercial Court & Court of Appeal.', led: 'Led by Hayes' },
  { ref: 'PA-07', t: 'Real Property', d: 'Trophy residential, prime commercial and rural estates. Regulated by SRA & the Law Society.', led: 'Led by Sterling' },
  { ref: 'PA-12', t: 'Tax & Reorganisations', d: 'Personal and corporate restructurings, residency, non-dom planning under the 2025 reforms.', led: 'Led by Voss' },
];
export const MATTERS = [
  { yr: 2025, t: 'Acted for [REDACTED] · £148M shareholder action · settlement secured at first round mediation', cat: 'Litigation' },
  { yr: 2025, t: 'Acted for [REDACTED] · cross-border family trust · 4 jurisdictions, principal trustee replaced', cat: 'Private Client' },
  { yr: 2024, t: 'Acted for [REDACTED] · acquisition of Grade I listed estate · £62M, with planning consent secured', cat: 'Real Property' },
  { yr: 2024, t: 'Acted for [REDACTED] · non-dom restructuring & residency change · pre-budget completion', cat: 'Tax' },
];
export const COUNSEL = [
  { name: 'Edmund Sterling QC', role: 'Senior Partner · Real Property', call: 'Called 1991 · Silk 2014', edu: 'BA Oxon · BCL · Lincoln’s Inn' },
  { name: 'Charlotte Hayes', role: 'Partner · Litigation', call: 'Called 1998 · Partner 2008', edu: 'BA Cantab · LLM Harvard' },
  { name: 'Dr. Marcus Whitford QC', role: 'Senior Partner · Private Client', call: 'Called 1985 · Silk 2009', edu: 'PhD Cambridge · LLM Yale' },
  { name: 'Helena Voss', role: 'Partner · Tax', call: 'Called 2003 · Partner 2014', edu: 'BA Bristol · MA · CTA' },
];
